"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _App = _interopRequireDefault(require("./App"));

var _dva = _interopRequireDefault(require("../../dva/dva"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

// 解决外部引用时的传参问题
var AppWrap =
/*#__PURE__*/
function (_Component) {
  _inherits(AppWrap, _Component);

  /* eslint-disable react/require-default-props, react/no-unused-prop-types */

  /* eslint-enable */
  function AppWrap(_props) {
    var _this;

    _classCallCheck(this, AppWrap);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(AppWrap).call(this, _props));

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "handleUpdateState", function (props) {
      var app = _this.dvaInstance.app;

      app._store.dispatch({
        type: 'global/saveState',
        payload: props
      });
    });

    _this.dvaInstance = (0, _dva.default)(_react.default.createElement(_App.default, null));

    _this.handleUpdateState(_props);

    return _this;
  }

  _createClass(AppWrap, [{
    key: "componentWillReceiveProps",
    value: function componentWillReceiveProps(nextProps) {
      this.handleUpdateState(nextProps);
    }
  }, {
    key: "render",
    value: function render() {
      var _this$dvaInstance = this.dvaInstance,
          Provider = _this$dvaInstance.Provider,
          app = _this$dvaInstance.app;
      return _react.default.createElement(Provider, {
        store: app._store
      }, _react.default.createElement(_App.default, null));
    }
  }]);

  return AppWrap;
}(_react.Component);

exports.default = AppWrap;

_defineProperty(AppWrap, "propTypes", {
  className: _propTypes.default.string
});